import { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { getMemberChart } from '../services/ api_services';


function MemberChart({daychart, refreshKey}) {
    
  const [chartdata, setChartdata] = useState([]);

  const fetchChart = async () => {
    try {
      const params = { periodType: daychart}
      const responseChart = await getMemberChart(params);
      // console.log(" ~fetchChart~ responseChart responseChart", responseChart);

      const groupedList = [];
      responseChart.data.forEach((item, index) => {
        console.log(item)
        groupedList.push({
          date: item[0],
            사용중: item[2],
            심사중: item[3],
        })
      }
    )
      setChartdata(groupedList);
      console.log("🚀 ~ ~ ~ params:", params, "chartdata:", chartdata);
    }
    catch (e) {
      console.log("e===>", e);
    }
  }

  useEffect(() => {
    fetchChart();
    console.log("🚀 ~ ~ e.value:", daychart);
  }, [daychart, refreshKey]);

  return (
    <div className='p-2'>
      <div className='flex justify-center'>
        <BarChart 
          data={chartdata}
          width={1000}
          height={300}
          fontSize={13}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
            <Bar dataKey="사용중" stackId="a" fill="#d4e8eb" />
            <Bar dataKey="심사중" stackId="a" fill="#ffc8be" />
        </BarChart>
      </div>
    </div>
  );
}

export default MemberChart;